import styled from 'styled-components';

export default styled.div`
  color: rgba(255, 98, 86, 1);
  position: absolute;
  bottom: -2.2rem;
  left: 1rem;
  width: 100%;
  font-size: 1.2rem;
  line-height: 2rem;
  ${props => props.thisStyles}
`;
